import React from 'react';

export default function ConstomErrorText({ text }) {
    return (
        <div className="error-text">
            {text}
        </div>
    )
}
